/**
 * address Group
 * @param fb : FormBuilder
 */
export function emailsGroup (fb: any):any {
    // return fb.array([
    //     fb.group({
    //         email: ['']
    //     })
    // ]);
    return [''];
}
